<template>
    <renraku-menu-list />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import syuugyoukisokuMenuList from '@/components/renraku/MenuList.vue';

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'renraku-menu-list': syuugyoukisokuMenuList
    }
})
</script>
